import Route from '@ember/routing/route';
import { later, cancel } from '@ember/runloop';
import { inject as service } from '@ember/service';

export default class ClassGroupResultsRoute extends Route 
{	
	@service ajax
	
	resultsTimer = null
	
	resultsRefreshInterval = 10000
	
	async model(params) 
	{
		const results = await this.fetchResults();	
		const penalties = await this.fetchPenalties();	
		return {results,penalties};
	}
	
	setupController(controller, model) 
	{		
		controller.set('results', model.results);
		controller.set('penalties', model.penalties);
	    controller.set('event', this.modelFor('event'));
		controller.set('classGroup',this.modelFor('event/class-group'));
	}
	
	async fetchResults()
	{
		let results = await this.ajax.request("individualResults");
		results = await results.map(function(result)
		{
			return result.data.attributes;
		});
		return results;
	}
	
	async fetchPenalties()
	{
		let penalties = await this.ajax.request("penalties");
		return penalties;
	}
	
	async fetchResultsLoop()
	{
		cancel(this.resultsTimer);
		this.resultsTimer = later(this,async function()
		{
			const results = await this.fetchResults();
			const penalties = await this.fetchPenalties();
			this.controller.set('results', results);
			this.controller.set('penalties', penalties);
			
			this.fetchResultsLoop();
		},this.resultsRefreshInterval);
	}
	
	activate(transition)
	{
		this.fetchResultsLoop();
	}
	
	deactivate(transition)
	{
		cancel(this.resultsTimer);
	}
}